<div class="host-coupon-list">

  <div class="coupon-list">
    <ng-container *ngIf="listOfCoupon?.length else empty">
      <ng-container *ngIf="pageType === 'operate'">
        <nz-radio-group [ngModel]="selectedCoupon">
        <div 
          class="coupon-item" 
          *ngFor="let item of listOfCoupon">
          <label nz-radio [nzValue]="item.code" [nzDisabled]="item.status === CouponStatus.Expired" (click)="onClickItem(item)">
            <div class="coupon-wrapper" [ngClass]="item.htmlClass">
              <span class="coupon-type">{{ item.name }}</span>
              <span class="coupon-time">{{ item.validity }}</span>
            </div>
          </label>
        </div>
        </nz-radio-group>
      </ng-container>
  
      <ng-container *ngIf="pageType === 'view'">
        <div 
          class="coupon-item" 
          *ngFor="let item of listOfCoupon">
            <div class="coupon-wrapper"  [ngClass]="item.htmlClass">
              <span class="coupon-type">{{ item.name }}</span>
              <span class="coupon-time">{{ item.validity }}</span>
            </div>
        </div>      
      </ng-container>
    </ng-container>

    <ng-template #empty>
      <div class="empty-container">
        <img src="/assets/pay/coupon-empty.png" class="empty-icon" alt="">
        <p class="empty-tip">{{ "modal.coupon.list.empty" | translate }}</p>
      </div>
    </ng-template>

    <div class="extra">
      <a href="javascript:void(0)" class="exchange-coupon" (click)="displayExchangeCouponModal(exchangeCouponTpl)">
        + {{ "modal.coupon.list.add" | translate }}
      </a>
      <p class="tip">
        <i nz-icon nzType="exclamation-circle" nzTheme="outline"></i>
        <span> 
          {{ "modal.coupon.list.tip" | translate }}
          <!-- 优惠券可在支付时使用，每次使用一个，不找零 -->
        </span>
      </p>
    </div>
  </div>

  <div class="footer" *ngIf="pageType === 'operate'">
    <button 
      nz-button 
      nzType="primary"
      (click)="onConfirm()">
      {{ "word.confirm" | translate }}
      <!-- 确定 -->
    </button>
  </div>

</div>

<ng-template #exchangeCouponTpl>
  <div class="exchange-coupon-container" style="padding: 12px 0 24px">
    <input type="text" nz-input hostAutoFocus [attr.placeholder]="'placeholder.coupon_list.add' | translate" [(ngModel)]="exchangeCouponCode">
  </div>
</ng-template>